import React, { useRef, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import ImageIcon from "../../icons/ImageIcon";
import CloseX from "../../icons/CloseX";
import Loading from "../../icons/Loading";
import dataLayerHandler from "../../../components/dataLayerHandler";

const HUBSPOT_EMBED_SRC = "https://js.hsforms.net/forms/embed/7476704.js";

const GetQuote = ({ product, closePopup }) => {
  const enquireForm = useRef(null);
  const formFrameRef = useRef(null);
  const [files, setFiles] = useState([]);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [enquireLoading, setEnquireLoading] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [formLoading, setFormLoading] = useState(true);

  useEffect(() => {
    if (document.querySelector(`script[src="${HUBSPOT_EMBED_SRC}"]`)) {
      return;
    }
    const script = document.createElement("script");
    script.src = HUBSPOT_EMBED_SRC;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  // Hide the loader once HubSpot has actually rendered the form.
  useEffect(() => {
    const frame = formFrameRef.current;
    if (!frame) {
      return undefined;
    }

    const startedAt = Date.now();
    const MIN_VISIBLE = 800; // keep the loader on screen long enough to be seen
    let settled = false;
    let hideTimer;

    const stopLoading = () => {
      if (settled) {
        return;
      }
      settled = true;
      const wait = Math.max(0, MIN_VISIBLE - (Date.now() - startedAt));
      hideTimer = window.setTimeout(() => setFormLoading(false), wait);
    };

    // 1. HubSpot posts this from the form iframe once it is ready.
    const onMessage = (event) => {
      const data = event.data;
      if (
        data &&
        data.type === "hsFormCallback" &&
        (data.eventName === "onFormReady" ||
          data.eventName === "onFormDefinitionFetchSuccess")
      ) {
        stopLoading();
      }
    };
    window.addEventListener("message", onMessage);

    // 2. CustomEvents dispatched by the newer embed script.
    window.addEventListener("hs-form-event:on-ready", stopLoading);
    window.addEventListener("hs-form-event:on-render", stopLoading);

    // 3. Fallback: the form markup has appeared inside the frame.
    const isRendered = () => !!frame.querySelector("iframe, form");
    const observer = new MutationObserver(() => {
      if (isRendered()) {
        stopLoading();
      }
    });
    observer.observe(frame, { childList: true, subtree: true });
    if (isRendered()) {
      stopLoading();
    }

    // 4. Hard fallback so the loader can never get stuck.
    const failSafe = window.setTimeout(() => setFormLoading(false), 12000);

    return () => {
      window.removeEventListener("message", onMessage);
      window.removeEventListener("hs-form-event:on-ready", stopLoading);
      window.removeEventListener("hs-form-event:on-render", stopLoading);
      observer.disconnect();
      window.clearTimeout(hideTimer);
      window.clearTimeout(failSafe);
    };
  }, [completed]);

  const onDrop = (acceptedFiles) => {
    const newFiles = acceptedFiles.filter(
      (newFile) => !files.some((existingFile) => existingFile.name === newFile.name)
    );
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: 'image/*',
    multiple: true,
  });

  const handleRemove = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (enquireLoading) {
      return false;
    }

    const data = new FormData(enquireForm.current);

    files.forEach((file) => {
      data.append("UploadedFiles[]", file);
    });

    setEnquireLoading(true);
    setCompleted(false);

    fetch('quote/submit', {
      method: 'POST',
      body: data
    }).then((response) => {
      if (response.ok) {
        setEnquireLoading(false);
        setCompleted(true);
        dataLayerHandler('quote_submitted', 'Quote for: ' + product.title);
        enquireForm.current.reset();
        setFiles([]);
        setTimeout(() => {
          setPopupOpen(false);
        }, 5000);
      } else {
        console.error('Error:', response.statusText);
        setEnquireLoading(false);
      }
    })
      .catch((error) => {
        console.error('Fetch error:', error);
        setEnquireLoading(false);
      });
    return false;
  };

  return (
    <>
      <div className="getQuote">
        <div className="getQuote__wrap">

          {completed && <p className="success-msg">
            Thanks for your enquiry. Expect a response soon! <button className="close-btn" onClick={closePopup}>
              <CloseX /></button>
          </p>}

          {!completed && <>
            <div className="getQuote__title">
              <h2>Enquire</h2>
              <button className="close-btn" onClick={closePopup}><CloseX /></button>
            </div>
            <div className="getQuote__intro">
              {product.is_skinned_site && (
                <p>To get a quote, fill out the form below. We'll then come back to you with pricing</p>
              )}

            </div>
            <div className="getQuote__form">
              {formLoading && (
                <div className="getQuote__form-loading">
                  <Loading />
                </div>
              )}
              <div
                ref={formFrameRef}
                className="hs-form-frame"
                data-region="na1"
                data-form-id="53f6ac07-28e1-49a9-bdfa-e98567c8c13e"
                data-portal-id="7476704"
              ></div>

              {/* <form method={'post'} onSubmit={onSubmit} ref={enquireForm}>

                <div className="getQuote__form__field getQuote__form__field--inline">
                  <label>Your Name*</label>
                  <input type="text" name={'Name'} id={'Name'} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__field--inline">
                  <label>Your Email*</label>
                  <input type="email" name={'Email'} id={'Email'} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__field--inline">
                  <label>Your Phone Number*</label>
                  <input type="tel" name={'Phone'} id={'Phone'} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__field--inline">
                  <label>Your Postcode*</label>
                  <input type="text" name={'Postcode'} id={'Postcode'} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__field--inline" style={{alignItems: 'flex-start'}}>
                  <div style={{minWidth: '25%'}}>
                    <label>Garment*</label>
                    <small className="text-secondary" style={{display: 'block', fontSize: '10px', margin: 0, lineHeight: 1.2}}>Add additional styles if required</small>
                  </div>
                  <input type="text" name={'Garment'} id={'Garment'} defaultValue={product.title} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__field--inline">
                  <label>Quantity*</label>
                  <input type="text" name={'Quantity'} id={'Quantity'} required/>
                </div>
                <div className="getQuote__form__field getQuote__form__comment">
                  <p>
                  Comments. For example, 'Small logo on left chest' (or anything else you want to tell us!).
                  </p>
                  <textarea name={'Comment'} id={'Comment'}/>
                </div>
    
                <input type="hidden" name={'ProductID'} id={'ProductID'} value={product.id} required/>

                <button className="btn btn--black">Submit Enquiry</button>
              </form> */}

            </div>
          </>}
        </div>
      </div>
    </>
  );
};

export default GetQuote;
